import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { defaultDataAcessor } from 'src/app/core/helpers/mat-sort-data-accessor';
import { ICoordenacaoModel } from 'src/app/models/coordenacao.model';
import { EnumAcaoRecurso } from 'src/app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from 'src/app/models/enum/recurso-perfil.enum';
import { IPermissaoModel } from 'src/app/models/permissao.model';
import { AuthService } from 'src/app/services/auth.service';
import { CoordenacaoService } from 'src/app/services/coordenacao.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-coordenacao-list',
  templateUrl: './coordenacao-list.component.html',
  styleUrls: ['./coordenacao-list.component.scss']
})
export class CoordenacaoListComponent extends BaseListComponent {
  public dataSource = new MatTableDataSource<ICoordenacaoModel>([]);
  public selectedModel: ICoordenacaoModel;
  public displayedColumns: string[] = ['selecao', 'sigla', 'nome', 'quantidadeServidores', 'ativo'];
  public searchNome: string;
  public searchAtivo = true;
  public semDados = true;
  public permissoes: IPermissaoModel;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private coordenacaoService: CoordenacaoService,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService
  ) {
    super();
    this.buscar();
  }

  ngOnInit(): void {
    this.setarPermissoes();
  }

  private setarPermissoes(): void {
    this.permissoes = new IPermissaoModel();
    this.permissoes.consultar = this.authService.possuiPermissao(EnumRecursoPerfil.Cadastros, EnumAcaoRecurso.Consultar);
    this.permissoes.editar = this.authService.possuiPermissao(EnumRecursoPerfil.Cadastros, EnumAcaoRecurso.Editar);
    this.permissoes.excluir = this.authService.possuiPermissao(EnumRecursoPerfil.Cadastros, EnumAcaoRecurso.Excluir);
    this.permissoes.inativarReativar = this.authService.possuiPermissao(EnumRecursoPerfil.Cadastros, EnumAcaoRecurso.AtivarInativar);
    this.permissoes.incluir = this.authService.possuiPermissao(EnumRecursoPerfil.Cadastros, EnumAcaoRecurso.Inserir);
    this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.Cadastros, EnumAcaoRecurso.Visualizar);
 }

  public novo() {
    this.router.navigate(['/coordenacoes/novo']);
  }

  public buscar() {
    this.selectedModel = null;

    this.coordenacaoService
      .obter(this.searchNome, this.searchAtivo, false)
      .then((res) => {
        this.dataSource = new MatTableDataSource<ICoordenacaoModel>(res.dados);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = defaultDataAcessor;
        this.dataSource._updateChangeSubscription();
        this.semDados = this.dataSource.filteredData.length === 0;
      })
      .catch((err) => {
        this.toastr.error(err.mensagem.descricao, 'Atenção');
      })
  }

  public reativar(id: number) {
    this.coordenacaoService
      .reativar(id)
      .then((res) => {
        if (res.sucesso) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            text: 'Coordenação reativada com sucesso.',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        } else {
          this.exibirMensagemAlerta(res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem.descricao);
      })
      .finally(() => {
        this.buscar();
      });
  }

  public inativar(id: number) {
    this.coordenacaoService
      .inativar(id)
      .then((res) => {
        if (res.sucesso) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            text: 'Coordenação inativada com sucesso.',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        } else {
          this.exibirMensagemAlerta(res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem.descricao);
      })
      .finally(() => {
        this.buscar();
      });
  }

  public editar(id: number) {
    this.router.navigate([`/coordenacoes/${id}`]);
  }

  public excluir(id: number) {
    this.coordenacaoService
      .excluir(id)
      .then((res) => {
        if (res.sucesso) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            text: 'Coordenação excluída com sucesso!',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        } else {
          console.log("passou aqui");
          this.exibirMensagemAlerta(res.mensagem.descricao, true);
        }
      })
      .catch((err) => {
        console.log("passou no catch");
        this.exibirMensagemErro(err.mensagem.descricao);
      })
      .finally(() => {
        this.buscar();
      });
  }

  public selecionar(item: any) {
    this.selectedModel = !this.selectedModel || this.selectedModel.id !== item.id ? item : null;
  }

  public visualizar(id: number) {
    this.router.navigate([`/coordenacoes/${id}/visualizar`]);
  }
}
